/// Port of mobile/lib/user/ui/guest_score_merge_host.dart.

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuthStore } from '@/auth/handler/authStore';
import { useThemeColors } from '@/settings/handler/settingsStore';
import { PixelContainer } from '@/ui/pixel/PixelContainer';
import { useGuestScoreMergeStore } from '@/user/handler/guestScoreMergeStore';
import { formatScore } from '@/utils/formatScore';

export function GuestScoreMergeHost() {
  const { t } = useTranslation();
  const colors = useThemeColors();
  const offer = useGuestScoreMergeStore((s) => s.offer);
  const accept = useGuestScoreMergeStore((s) => s.accept);
  const decline = useGuestScoreMergeStore((s) => s.decline);

  useEffect(() => {
    if (!offer) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [offer]);

  if (!offer) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-6"
      style={{ backgroundColor: 'rgba(0,0,0,0.45)' }}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="w-full max-w-sm p-5"
        style={{ backgroundColor: colors.surface, color: colors.onSurface }}
      >
        <h2 className="text-center leading-tight" style={{ fontSize: 28 }}>
          {t('guestScoreMergeTitle')}
        </h2>
        <p
          className="mt-3 text-center"
          style={{ fontSize: 16, lineHeight: 1.35, opacity: 0.75 }}
        >
          {t('guestScoreMergeMessage', {
            guestScore: formatScore(offer.guestScore),
            accountScore: formatScore(offer.accountScore),
          })}
        </p>
        <div className="mt-5 flex flex-col gap-2.5">
          <PixelContainer
            radius={3}
            pixelScale={2}
            padding="12px 0"
            backgroundColor={colors.onSurface}
            borderColor={colors.onSurface}
            className="w-full"
            onClick={() => {
              const guestScore = offer.guestScore;
              void accept().then((updated) => {
                if (updated) {
                  useAuthStore.setState({ user: updated });
                  return;
                }
                useAuthStore.setState((state) => ({
                  user: {
                    ...state.user,
                    highScore: Math.max(state.user.highScore, guestScore),
                  },
                }));
              });
            }}
          >
            <div className="flex justify-center">
              <span className="leading-none" style={{ fontSize: 20, color: colors.surface }}>
                {t('guestScoreMergeKeep')}
              </span>
            </div>
          </PixelContainer>
          <PixelContainer
            radius={3}
            pixelScale={2}
            padding="12px 0"
            backgroundColor={colors.surfaceContainerHighest}
            borderColor={colors.onSurface}
            className="w-full"
            onClick={() => decline()}
          >
            <div className="flex justify-center">
              <span className="leading-none" style={{ fontSize: 20, color: colors.onSurface }}>
                {t('guestScoreMergeDiscard')}
              </span>
            </div>
          </PixelContainer>
        </div>
      </div>
    </div>
  );
}
